module.exports = __webpack_public_path__ + "media/applicants/work-whenever-687f481d.svg";